var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllBookingsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-bookings-active_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "13.086%",
    y2: "83.546%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#202E4A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-bookings-active_svg__a)",
    strokeWidth: 2,
    d: "M20.297 19.228H1.925c-.796 0-1.442-.772-1.442-1.725V2.69c0-.952.646-1.725 1.442-1.725h18.372c.796 0 1.442.773 1.442 1.725v14.814c0 .953-.646 1.725-1.442 1.725z",
    transform: "translate(4.611 5.444)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.083,
    d: "M20.706 12.016h-6.393m6.393 4.167h-6.393m6.393 4h-6.393m-3.607-8.167h-.5m.5 4.167h-.5m.5 4h-.5"
  }))));
}
export default SvgAllBookingsActive;